<template>
  <div class="new-additional-form">
    <div class="create-contract">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        style="display: flex"
      >
        <el-form-item prop="number" style="width: 80%; margin-right: 2%">
          <el-input
            v-model="ruleForm.number"
            placeholder="Введите номер документа"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loadingContracts"
            plain
            type="primary"
            @click="createContractHandler('ruleForm')"
          >
            Создать новый договор
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewAdditionalsForm',
  props: {
    contractId: {
      type: Number,
      required: true,
    },
    loadingContracts: {
      type: Boolean,
      default: false,
    },
    contracts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ruleForm: {
        number: '',
      },
      rules: {
        number: [
          {
            required: true,
            message: 'Введите номер документа',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 100,
            message: 'Минимально 3 символа',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    createContractHandler(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.contracts) {
            this.$emit('createContract')
            this.ruleForm.number = ''
          } else {
            this.$emit('createDocument', {
              number: this.ruleForm.number,
              contract_id: this.contractId,
            })
            this.ruleForm.number = ''
          }
        } else {
          console.log('error submit!!')

          return false
        }
      })
    },
  },
}
</script>

<style lang="sass">
.new-additional-form
  width: 100%
.create-contract
  & .header
    & b
      padding: 10px 10px 0 10px
      display: block
      &:first-child
        padding-left: 0
      &:last-child
        padding-right: 0
  & .no-contracts
    height: 120px
    & .text
      text-transform: uppercase
      font-weight: 500
  & .text-align-right
    text-align: right
  & .el-date-editor.el-input
    width: 100%
  & a.create-new-contract
    color: #FF0000
    text-decoration: underline
  & .move-to-files
    color: #3498DB
    text-decoration: underline
  & .number-document
    margin: 20px 0
</style>
